import React, { useEffect, useState, useCallback } from "react";
import { Api_Token } from "../../util/Api"; // Remplace avec ta logique pour l'API token
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  IconButton,
  Grid,
  CardContent,
  Pagination
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import CustomAlert from "../../components/Alert/AlertCustomer";

import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import ModelVirement from "../../components/popup/ModelVirement";
import Datepicker from "react-tailwindcss-datepicker";
import LabelTypography from "../../components/Typography/LabelTypography";

function VirementManagementPage() {
  return <Indexdasboard Children={<VirementList />} />;
}

const VirementList = () => {
  const [virements, setVirements] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [AlertEtat, setAlertEtat] = useState("initial");
  const [AlertMessage, setAlertMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [DateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [formData, setFormData] = useState({
    nom_expediteur: "",
    numero_transaction: "",
    banque: "",
    montant: "",
  });
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const fetchVirements = useCallback(
    async (currentPage, rowsPerPage, DateRange) => {
      try {
        let url = `/virements/getVirementPaginate?page=${
          currentPage + 1
        }&perPage=${rowsPerPage}`;
        const formattedStartDate = DateRange.startDate
          ? new Date(DateRange.startDate).toISOString().split("T")[0]
          : null;
        const formattedEndDate = DateRange.endDate
          ? new Date(DateRange.endDate).toISOString().split("T")[0]
          : null;
        if (formattedEndDate && formattedStartDate) {
          url += `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
        }
        const response = await Api_Token.get(url);
        setVirements(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching virements:", error);
      }
    },
    []
  );

  useEffect(() => {
    fetchVirements(page, rowsPerPage, DateRange);
  }, [fetchVirements, page, rowsPerPage, DateRange]);

  const handleSubmit = async () => {
    try {
      if (formData.id) {
        await Api_Token.post(`/virements/update/${formData.id}`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Virement updated successfully!"));
      } else {
        await Api_Token.post(`/virements`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Virement created successfully!"));
      }
      fetchVirements(page, rowsPerPage);
      handleCloseModal();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error submitting form: ") + error.message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (
    virement = {
      nom_expediteur: "",
      numero_transaction: "",
      banque: "",
      montant: "",
    }
  ) => {
    setFormData(virement);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setError(null);
  };

  return (
    <Box>
      <TitreGraphik> {t("Gestion des Virements")}</TitreGraphik>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Card
          sx={{
            padding: "2%",
            marginTop: "2%",
            minHeight: "600px",
            width: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Datepicker
                inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                primaryColor={"blue"}
                value={DateRange}
                onChange={(newDateRange) => {
                  setDateRange(newDateRange);
                  setPage(0);
                }}
                showShortcuts={true}
                showFooter={true}
                popoverDirection="down"
              />
            </Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ marginTop: "20px" }}>
                <Table sx={{ minWidth: 650 }} aria-label="virements table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {t("ID")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Nom Expéditeur")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Numéro de Transaction")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Banque")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Montant")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Image")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {"Actions"}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {virements?.map((virement) => (
                      <StyledTableRow key={virement.id}>
                        <StyledTableCell align="center">
                          {virement.id}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {virement.nom_expediteur}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {virement.numero_transaction}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {virement.banque}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <NumericFormatEnv Number={virement.montant} />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {virement.image ? (
                            <img
                              src={virement.image}
                              alt="Virement"
                              style={{ width: "50px", height: "50px" }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <IconButton onClick={() => handleOpenModal(virement)}>
                            <EditIcon />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Grid>
        </Card>
      </Box>
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Grid container spacing={2} sx={{ marginTop: "20px", width: "100%" }}>
          <Grid item xs={12}>
            <Card>
              <Datepicker
                inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                primaryColor={"blue"}
                value={DateRange}
                onChange={(newDateRange) => {
                  setDateRange(newDateRange);
                  setPage(0);
                }}
                showShortcuts={true}
                showFooter={true}
                popoverDirection="down"
              />
            </Card>
          </Grid>
          {virements.map((virement) => (
            <Grid item xs={12} sm={6} md={4} key={virement.id}>
              <Card sx={{ padding: 2 }}>
                <CardContent>
                  <LabelTypography variant="h6" align="center">
                    #{virement.id}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Nom Expéditeur")}:</strong>{" "}
                    {virement.nom_expediteur}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Numéro de Transaction")}:</strong>{" "}
                    {virement.numero_transaction}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Banque")}:</strong> {virement.banque}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Montant")}:</strong>{" "}
                    <NumericFormatEnv Number={virement.montant} />
                  </LabelTypography>
                  {virement.image && (
                    <LabelTypography align="center" sx={{ marginTop: 1 }}>
                      <img
                        src={virement.image}
                        alt="Virement"
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "8px",
                        }}
                      />
                    </LabelTypography>
                  )}
                  <Grid
                    container
                    justifyContent="center"
                    spacing={1}
                    sx={{ marginTop: 2 }}
                  >
                    <Grid item>
                      <IconButton onClick={() => handleOpenModal(virement)}>
                        <EditIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box
              sx={{
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Pagination
                count={Math.ceil(totalCount / rowsPerPage)}
                onChange={(event, newPage) => {
                  setPage(newPage - 1); // Adjust for 0-based indexing
                }}
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <ModelVirement
        open={openModal}
        onClose={handleCloseModal}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        error={error}
      />

      <CustomAlert
        open={AlertEtat !== "initial"}
        onClose={() => {
          setAlertEtat("initial");
        }}
        etat={AlertEtat}
        message={AlertMessage}
      />
    </Box>
  );
};

export default VirementManagementPage;
